import React from 'react';

const ExerciseCard = ({
  children,
  colorBorder,
  className = '',
  padding = 'p-5'
}) => {
  const borderClasses = {
    purple: 'border-l-4 border-purple-500',
    amber: 'border-l-4 border-amber-500',
    blue: 'border-l-4 border-blue-500',
    rose: 'border-l-4 border-rose-500'
  };

  const border = colorBorder ? borderClasses[colorBorder] : '';

  return (
    <div className={`bg-white rounded-2xl shadow-lg ${padding} ${border} ${className}`}>
      {children}
    </div>
  );
};

export default ExerciseCard;
